import { useCallback, useMemo } from 'react';

import { useQuizFormField } from '../hook/useQuizFormField';

export const useAnswerControl = ({ index: choiceIndex }: { index: number }) => {
  const [isAnswer, updateIsAnswer] = useQuizFormField({
    field: `multipleData.choiceList.${choiceIndex}.isAnswer`,
  });
  const [choiceList, _] = useQuizFormField({
    field: 'multipleData.choiceList',
  });

  const toggleDisabled = useMemo(() => {
    const currentAnswerCount = choiceList.filter(
      choice => choice.isAnswer,
    ).length;
    return isAnswer && currentAnswerCount === 1;
  }, [isAnswer, choiceList]);

  const handleToggle = useCallback(() => {
    if (toggleDisabled) return;
    updateIsAnswer(!isAnswer);
  }, [updateIsAnswer, isAnswer, toggleDisabled]);

  return {
    isAnswer,
    handleToggle,
  };
};
